import type {AddComponentTypeOptions} from 'grapesjs';
import {FORM_SPACER_STYLES} from '@FormMakerReact/components/component-styles';

export const POSTERMYWALL_FORM_SPACER_TYPE = 'postermywall-form-spacer';
const DATA_ATTR = 'data-is-pmw-form-spacer';

export const POSTERMYWALL_FORM_SPACER: AddComponentTypeOptions = {
  isComponent: (el: HTMLElement) => {
    if (typeof el.getAttribute !== 'function') {
      return undefined;
    }
    return el.tagName === 'DIV' && el.getAttribute(DATA_ATTR) !== null ? {type: POSTERMYWALL_FORM_SPACER_TYPE} : undefined;
  },
  model: {
    defaults: {
      tagName: 'div',
      toolbar: [],
      copyable: false,
      draggable: false,
      droppable: false,
      hoverable: false,
      selectable: false,
      highlightable: false,
      badgable: false,
      style: FORM_SPACER_STYLES,
      attributes: {
        [DATA_ATTR]: '1',
        id: POSTERMYWALL_FORM_SPACER_TYPE,
      },
    },
  },
};
